/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { SquareBox as icon } from '../../components/Icons';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Grid Item' ),
	description: __( 'Gutenify grid item.' ),
	icon: <Icon icon={ icon } />,
	parent: [ 'gutenify/grid' ],
	keywords: [
		'gutenify',
		__( 'grid item' ),
		__( 'grids' ),
		__( 'columns' ),
		__( 'column' ),
	],
	example: {
		attributes: {
			image: {
				url: '',
				id: '',
			},
		},
	},
	attributes,
	edit,
	save,
	supports: {
		html: false,
		anchor: true,
		align: [ 'wide', 'full' ],
	},
};

export { name, category, settings };
